const hamburger = $('.hamburger');
const mainMenu = $('.menu-wrapper');

$('button[data-menu-toggle]').on('click', function(){
    if($(hamburger).is(':visible')){
        if($(hamburger).hasClass('is-active')){
            menu.close();
        } else {
            menu.open();
        }
    }
})

function setupMenu(){
    function open() {
        anime({
            targets: mainMenu[0],
            maxHeight: "100vh",
            duration: 500,
            easing: 'easeInExpo',
            begin: () => {
                $(mainMenu).addClass('is-active');
                $(hamburger).addClass('is-active');
            }
        })
    }

    function close() {
        anime({
            targets: mainMenu[0],
            maxHeight: 0,
            duration: 500,
            easing: 'easeOutExpo',
            complete: ()=> {
                $(mainMenu).removeClass('is-active');
                $(hamburger).removeClass('is-active');
            }
        })
    }

    var publicAPI = {
        open,
        close
    }

    return publicAPI;
}